exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-base .btn-refresh:hover {\n  cursor: pointer; }\n", ""]);

// exports
